var map = {
	"./build1005.png": "02e5",
	"./build1010.png": "1532",
	"./build1020.png": "17eb",
	"./build1030.png": "dcc2",
	"./build1040.png": "31c8",
	"./build1050.png": "2423",
	"./build1060.png": "4037"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "609b";